var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChatSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 34,
    viewBox: "0 0 34 34",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#7f8281",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.6667 1.38889c-8.43772 0-15.27781 6.84009-15.27781 15.27781 0 8.4377 6.84009 15.2777 15.27781 15.2777 8.4377 0 15.2777-6.84 15.2777-15.2777 0-8.43772-6.84-15.27781-15.2777-15.27781zm-16.6667 15.27781c0-9.20478 7.46192-16.6667 16.6667-16.6667 9.2047 0 16.6666 7.46192 16.6666 16.6667 0 9.2047-7.4619 16.6666-16.6666 16.6666-9.20478 0-16.6667-7.4619-16.6667-16.6666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.0983 8.65585c.276-.26633.7156-.25851.982.01748 1.2856 1.33227 2.9465 2.24137 4.7616 2.60627 1.8151.365 3.6982.1685 5.3989-.5633.3523-.1516.7608.0111.9124.3634s-.0111.7608-.3634.9124c-1.9598.8433-4.13 1.0697-6.2217.6491-2.0917-.4205-4.0057-1.4682-5.4873-3.00341-.2663-.27598-.2585-.71561.0175-.98194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6667 6.94444c-2.8765 0-5.2084 2.33186-5.2084 5.20836s2.3319 5.2083 5.2084 5.2083 5.2083-2.3318 5.2083-5.2083-2.3318-5.20836-5.2083-5.20836zm-6.5973 5.20836c0-3.64357 2.9537-6.59724 6.5973-6.59724 3.6435 0 6.5972 2.95367 6.5972 6.59724 0 3.6435-2.9537 6.5972-6.5972 6.5972-3.6436 0-6.5973-2.9537-6.5973-6.5972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.1028 21.0578c1.6644-1.0539 3.5939-1.6135 5.5639-1.6135s3.8995.5596 5.5638 1.6135c1.6644 1.0539 2.9952 2.5589 3.8375 4.3397.164.3467.0159.7607-.3308.9247s-.7607.0159-.9247-.3308c-.7298-1.543-1.8829-2.847-3.325-3.7602s-3.1139-1.398-4.8208-1.398-3.3788.4848-4.8209 1.398-2.59514 2.2172-3.32498 3.7602c-.16399.3467-.57799.4948-.92469.3308-.34671-.164-.49483-.578-.33084-.9247.84233-1.7808 2.17314-3.2858 3.83751-4.3397z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChatSingle);
export default __webpack_public_path__ + "static/media/ico_chat_single.f7a0c93af56422d2acfded8f59ef1ca3.svg";
export { ForwardRef as ReactComponent };